function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useRef, useState } from "react";
import { useSwipeable } from "react-swipeable";
import "./filtermodal.scss";
export const FilterModal = _ref => {
  let {
    closeModal,
    header,
    ariaLabelText,
    children
  } = _ref;
  const [initial, setInitial] = useState(0);
  const [contentHover, setContentHover] = useState(false);
  const filtersRef = useRef(null);
  const filtersBackdropRef = useRef(null);
  const filtersContentRef = useRef(null);
  const filtersForegroundContentRef = useRef(null);
  const close = () => {
    document.body.classList.remove("no-scroll");
    closeModal();
  };
  const swipeHandlers = useSwipeable({
    onSwipeStart: () => {
      var _filtersContentRef$cu;
      setInitial(parseFloat(((_filtersContentRef$cu = filtersContentRef.current) === null || _filtersContentRef$cu === void 0 ? void 0 : _filtersContentRef$cu.style.marginTop.replace("px", "")) || "") || 0);
    },
    onSwiping: eventData => {
      const contentRef = filtersContentRef.current;
      const backdropRef = filtersBackdropRef.current;
      if (!contentRef || !backdropRef) {
        return;
      }
      let pos = initial + eventData.deltaY;
      const startingTransparency = 0.6;
      if (pos <= 0) {
        pos = 0;
      } else {
        const transparency = startingTransparency - startingTransparency / 100 * (pos / window.innerHeight * 100);
        backdropRef.style.backgroundColor = "rgba(0, 0, 0, ".concat(Math.min(transparency, 1), ")");
      }
      contentRef.style.marginTop = "".concat(pos, "px");
    },
    onSwiped: eventData => {
      const ref = filtersRef.current;
      const contentRef = filtersContentRef.current;
      const backdropRef = filtersBackdropRef.current;
      if (!ref || !contentRef || !backdropRef) {
        return;
      }
      ref.style.transition = "background-color 200ms";
      contentRef.style.transition = "margin 200ms";

      // Close filter if we've scrolled past 50%
      if (initial + eventData.deltaY >= window.innerHeight / 2) {
        backdropRef.style.backgroundColor = "rgba(0, 0, 0, 0)";
        contentRef.style.marginTop = "".concat(window.innerHeight, "px");
        setTimeout(close, 200);
      } else {
        backdropRef.style.backgroundColor = "";
        contentRef.style.marginTop = "0";
      }
      setTimeout(() => {
        backdropRef.style.transition = "";
        contentRef.style.transition = "";
      }, 200);
    },
    trackMouse: true
  });
  useEffect(() => {
    document.body.classList.add("no-scroll");
    if (!filtersForegroundContentRef.current) {
      return;
    }
    const foreground = filtersForegroundContentRef.current;
    foreground.style.height = "".concat(foreground.scrollHeight, "px");
    const resizeHandler = () => foreground.style.height = "".concat(foreground.scrollHeight, "px");
    window.addEventListener("resize", resizeHandler);
    return () => window.removeEventListener("resize", resizeHandler);
  }, []);
  useEffect(() => {
    let startY = 0;
    const handleScrolling = deltaY => {
      if (filtersForegroundContentRef !== null && filtersForegroundContentRef.current !== null && !contentHover) {
        filtersForegroundContentRef.current.scrollTop += deltaY;
      }
    };
    const handleTouchMove = event => {
      if (startY !== 0) {
        const deltaY = event.touches[0].pageY - startY;
        handleScrolling(deltaY);
      }
      startY = event.touches[0].pageY;
    };
    const handleTouchEnd = () => {
      startY = 0;
    };
    const handleWheelScroll = event => {
      handleScrolling(event.deltaY);
    };
    window.addEventListener("wheel", handleWheelScroll);
    window.addEventListener("touchmove", handleTouchMove);
    window.addEventListener("touchend", handleTouchEnd);
    return () => {
      window.removeEventListener("wheel", handleWheelScroll);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, [contentHover]);
  return /*#__PURE__*/React.createElement("div", {
    className: "filters",
    ref: filtersRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters-backdrop",
    onClick: close,
    ref: filtersBackdropRef
  }), /*#__PURE__*/React.createElement("div", {
    className: "filters-foreground",
    ref: filtersContentRef
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: "filters-foreground-header"
  }, swipeHandlers), /*#__PURE__*/React.createElement("div", {
    className: "filters-foreground-header-line"
  }), header && /*#__PURE__*/React.createElement("h2", {
    className: "text-center fs-h4 pb-4"
  }, header), /*#__PURE__*/React.createElement("button", {
    className: "filters-close",
    onClick: close,
    "aria-label": ariaLabelText
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa-regular fa-xmark"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "filters-foreground-header-lg"
  }, header && /*#__PURE__*/React.createElement("h2", {
    className: "text-center fs-h4 pb-4 pt-4"
  }, header), /*#__PURE__*/React.createElement("button", {
    className: "filters-close",
    onClick: close,
    "aria-label": ariaLabelText
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa-regular fa-xmark"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "filters-foreground-content p-xs-6 pt-6 pb-4 pl-8 pr-8",
    ref: filtersForegroundContentRef,
    onMouseEnter: () => {
      setContentHover(true);
    },
    onMouseLeave: () => {
      setContentHover(false);
    }
  }, children)));
};